import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPageText: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="page-text"><path d="M4.75 2.75H19.25V21.25H4.75V2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 6.75H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 10.75H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 14.75H11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPageText;
